import { InputProps } from 'antd';
import { Field } from 'formik';
import { PropsWithChildren } from 'react';
import cx from 'classnames';
import style from './input-field.module.scss';

export const InputField = (props: PropsWithChildren<InputProps>) => {
  return <Field className={cx(style.inputField)} {...props} />;
};
